import React from 'react';
import { motion } from 'framer-motion';
import { 
  FaArrowRight,
  FaWhatsapp,
  FaClock,
  FaBolt,
  FaWater,
  FaFire,
  FaCrosshairs,
  FaHandHoldingHeart,
  FaRunning,
  FaUserInjured,
  FaUserMd
} from 'react-icons/fa';
import './Services.css';
// Carrusel
import logo from '../images/logo_JaviFisio.jpg';
import ImageCarousel from './ImageCarousel';
import masajeGemelo from '../images/masaje_gemelo.jpg';
import masaje from '../images/masaje.jpg';
import tobillo from '../images/tobillo.jpg';
import tumbado from '../images/tumbado.jpg';
import vendaje from '../images/vendaje.jpg';
import azulvendado from '../images/azulvendado.jpg';
import radiomaquina from '../images/máquina_radiofrecuencia.jpg';
import tratamientoradio from '../images/tratamiento_radiofrecuencia.jpg';

const Services = () => {
  const services = [
    {
      icon: <FaBolt />,
      title: "ENA",
      description: "La Electroneuroacupuntura o ENA es una técnica que combina acupuntura tradicional con estimulación eléctrica para modular el sistema nervioso, reducir el dolor y acelerar la recuperación neuromuscular.",
      features: [
        "Tendinopatía Aquílea",
        "Esguince de tobillo", 
        "Fascitis plantar, neuroma de morton",
        "Pubalgia",
        "Patología de rodilla",
        "Epicondilitis y epitrocleitis",
        "Patología de hombro",
        "Síndrome de túnel carpiano",
        "Lumbalgias (ciáticas)",
        "Dorsalgias",
        "Cervicalgias (cefaleas, migrañas)",
        "Patologías de cara y cabeza (bruxismo, parálisis facial)",
        "Tratamiento de cicatrices"
      ],
      advantages: [
        "Reducción del dolor",
        "Mejora el rendimiento muscular", 
        "Acelera la recuperación neuromuscular",
        "Disminución de la inflamación"
      ],
    },
    {
      icon: <FaFire />,
      title: "Radiofrecuencia",
      description: "La radiofrecuencia es una técnica terapéutica que emplea corrientes electromagnéticas de alta frecuencia para generar calor profundo y controlado en los tejidos. Este estímulo favorece la regeneración celular, mejora la circulación y acelera la recuperación de lesiones musculares, tendinosas y articulares.",
      features: [
        "Dolor crónico (lumbalgias, cervicalgias, etc.)",
        "Lesiones musculares y tendinosas (contracturas, tendinitis, desgarros)",
        "Artrosis y procesos degenerativos",
        "Rehabilitación postquirúrgica",
        "Edemas e inflamaciones",
        "Mejora del tono y elasticidad muscular y de la piel (también se usa en estética)",
        "Cicatrización y recuperación de tejidos"
      ],
      advantages: [
        "No invasiva: no requiere cirugía ni penetración de la piel.",
        "Indolora: produce una sensación de calor agradable.",
        "Estimula la regeneración de tejidos blandos.",
        "Activa la circulación sanguínea y linfática.",
        "Reduce el dolor y la inflamación.",
        "Acelera la recuperación de lesiones.",
        "Compatible con otros tratamientos fisioterapéuticos."
      ],
    },
    {
      icon: <FaCrosshairs />,
      title: "Punción Seca",
      description: "Técnica invasiva utilizada en fisioterapia que consiste en introducir una aguja fina en el músculo, específicamente en un punto gatillo o nudos musculares buscando la respuesta espasmo local (REL) del mismo. El objetivo es aliviar el dolor, reducir la tensión muscular, mejorar el movimiento y la circulación local.",
      features: [
        "Elimina puntos gatillo y contracturas",
        "Alivio rápido del dolor muscular",
        "Mejora la movilidad",
        "Previene lesiones",
        "Favorece una mejor biomecánica",
        "Tratamiento localizado y preciso"
      ],
    },
    {
      icon: <FaHandHoldingHeart />,
      title: "Fisioterapia Traumatológica",
      description: "Tratamiento integral para aliviar dolores musculares, articulares y mejorar la movilidad general. Incluye técnicas manuales, ejercicios terapéuticos y educación del paciente.",
      features: [
        "Evaluación personalizada",
        "Tratamiento manual",
        "Ejercicios terapéuticos",
        "Seguimiento continuo",
        "Educación del paciente",
        "Prevención de lesiones"
      ],
    },
    {
      icon: <FaWater />,
      title: "Presoterapia",
      description: "Tratamiento que estimula la circulación linfática y venosa para reducir inflamación, recuperarte más rápido y prevenir lesiones",
      features: [
        "Estimula la circulación linfática",
        "Reduce la inflamación",
        "Drenaje de líquidos",
        "Previene lesiones"
      ],
    },
    {
      icon: <FaRunning />,
      title: "Fisioterapia Deportiva",
      description: "Especializada en lesiones deportivas, recuperación post-competición y prevención de lesiones. Enfoque específico para deportistas y personas activas.",
      features: [
        "Lesiones deportivas",
        "Vendajes funcionales",
        "Recuperación muscular",
        "Prevención de lesiones",
        "Readaptación deportiva",
        "Optimización del rendimiento",
        "Técnicas específicas deportivas"
      ],
    },
    {
      icon: <FaUserInjured />,
      title: "Rehabilitación Post-Quirúrgica",
      description: "Programas específicos para recuperación después de cirugías ortopédicas y traumatológicas. Seguimiento de protocolos médicos personalizados.",
      features: [
        "Evaluación post-quirúrgica",
        "Protocolos específicos",
        "Recuperación funcional",
        "Control del dolor",
        "Seguimiento médico",
        "Reintegración gradual"
      ],
    },
    {
      icon: <FaUserMd />,
      title: "Terapia Manual",
      description: "Técnicas manuales avanzadas para tratar problemas de columna, articulaciones y tejidos blandos. Incluye osteopatía y técnicas específicas.",
      features: [
        "Técnicas manuales",
        "Movilización articular",
        "Liberación miofascial",
                "Manipulación vertebral",
        "Técnicas de tejidos blandos"
      ],
    }
  ];

  const benefits = [
    {
      icon: <FaBolt />,
      title: "Técnicas Avanzadas",
      description: "Especializado en ENA y Punción Seca con formación continua en las técnicas más efectivas."
    },
    {
      icon: <FaClock />,
      title: "Horarios Flexibles",
      description: "Adapto mis horarios a tu disponibilidad, incluyendo tardes."
    },
    {
      icon: <FaCrosshairs />,
      title: "Tratamiento Especializado",
      description: "Cada tratamiento se adapta específicamente a tu patología y objetivos de recuperación."
    }
  ];

  return (
    <div className="services">
      {/* Hero Section */}
      <section className="services-hero">
        <div className="container">
          <motion.div 
            className="services-hero-content"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1>Especialidades en Fisioterapia</h1>
            <p className="subtitle">
              Técnicas avanzadas de Electroneuroacupuntura (ENA) y Punción Seca 
              para el tratamiento efectivo del dolor y la recuperación neuromuscular.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="services-grid section">
        <div className="container">
          <div className="services-list">
            {services.map((service, index) => (
              <motion.div 
                key={index}
                className="service-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
              >
                <div className="service-header">
                  <div className="service-icon">
                    {service.icon}
                  </div>
                  <h3>{service.title}</h3>
                  <p className="service-description">{service.description}</p>
                </div>
                
                <div className="service-features">
                  <h4>Patologías que trata:</h4>
                  <ul>
                    {service.features.map((feature, featureIndex) => (
                      <li key={featureIndex}>{feature}</li>
                    ))}
                  </ul>
                </div>

                {service.advantages && (
                  <div className="service-advantages">
                    <h4>Ventajas:</h4>
                    <ul>
                      {service.advantages.map((advantage, advantageIndex) => (
                        <li key={advantageIndex}>{advantage}</li>
                      ))}
                    </ul>
                  </div>
                )}
                
                <a href="https://wa.me/34654384937" className="btn btn-primary service-cta">
                  <FaWhatsapp />
                  Consultar Disponibilidad
                </a>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Carousel */}
      <section className="section">
        <div className="container">
          <motion.div 
            className="section-header"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h2>Galería</h2>
            <p>Algunas imágenes del trabajo y resultados</p>
          </motion.div>
          <ImageCarousel
            images={[
              { src: radiomaquina, alt: 'Máquina de Radiofrecuencia' },
              { src: tratamientoradio, alt: 'Tratamiento con Radiofrecuencia' },
              { src: masajeGemelo, alt: 'Masaje Gemelo' },
              { src: masaje, alt: 'Masaje' },
              { src: tobillo, alt: 'Tobillo' },
              { src: tumbado, alt: 'Tumbado' },
              { src: vendaje, alt: 'Vendaje' },
              { src: azulvendado, alt: 'Azulvendado' }                    
            ]}
          />
        </div>
      </section>

      {/* Benefits Section */}
      <section className="benefits section">
        <div className="container">
          <motion.div 
            className="section-header"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h2>¿Por qué elegir mis servicios?</h2>
            <p>Ofrezco la mejor atención con las técnicas más avanzadas</p>
          </motion.div>
          
          <div className="benefits-grid">
            {benefits.map((benefit, index) => (
              <motion.div 
                key={index}
                className="benefit-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.2 }}
                viewport={{ once: true }}
              >
                <div className="benefit-icon">
                  {benefit.icon}
                </div>
                <h3>{benefit.title}</h3>
                <p>{benefit.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="services-cta section">
        <div className="container">
          <motion.div 
            className="cta-content"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h2>¿No encuentras el servicio que buscas?</h2>
            <p>
              Cada paciente es único. Si tienes una necesidad específica, 
              no dudes en consultarme. Estoy aquí para ayudarte.
            </p>
            <div className="cta-buttons">
              <a href="https://wa.me/34654384937" className="btn btn-primary">
                <FaWhatsapp />
                Consultar por WhatsApp
              </a>
              <a href="/contacto" className="btn btn-secondary">
                Ver Información de Contacto
                <FaArrowRight />
              </a>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Services; 